import { useCallback } from "react"
import { useQueryClient } from "@tanstack/react-query"

import { useUserContext } from "../providers"
import { useDeleteRequest } from "./useRequest"

export const useCancelAttendance = (experienceId: string, userId: string) => {
  const { accessToken } = useUserContext()
  const queryClient = useQueryClient()
  const { deleteRequest, deleteRequestAsync, ...rest } = useDeleteRequest({
    path: `/v1/experiences/${experienceId}/attendees/${userId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  const cancelAttendanceAsync = useCallback(
    async () => {
      const result = await deleteRequestAsync(null)
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["v1/experiences"],
        }),
        queryClient.invalidateQueries({
          predicate: (query) => {
            const key = query.queryKey[0]
            return (
              typeof key === "string" &&
              key.includes("/users/") &&
              key.includes("/experiences")
            )
          },
        }),
      ])
      return result
    },
    [deleteRequestAsync, queryClient],
  )

  return {
    cancelAttendance: deleteRequest,
    cancelAttendanceAsync,
    ...rest,
  }
}
